var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L3.5 3.33333L6 1L8.5 3.33333L11 1L13.5 3.33333L16 1L18.5 3.33333L21 1V31L18.5 28.6667L16 31L13.5 28.6667L11 31L8.5 28.6667L6 31L3.5 28.6667L1 31V1Z",
    fill: "#F5DADF",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79616 11.328H8.79216C8.85216 11.556 8.90016 11.784 8.90016 12.06C8.90016 12.96 8.26416 13.572 7.60416 14.184L8.43216 15.096C8.91216 14.82 9.29616 14.652 9.82416 14.652C10.5562 14.652 10.7842 15.096 11.6482 15.096C12.4882 15.096 13.0882 14.64 13.6282 13.692L12.5962 13.044C12.2722 13.596 12.0322 13.716 11.7322 13.716C11.1682 13.716 11.0242 13.356 10.4362 13.356C10.0042 13.356 9.58416 13.536 9.24816 13.74C9.76416 13.296 10.2202 12.78 10.2202 11.784C10.2202 11.616 10.2082 11.472 10.1842 11.328H11.8402V9.936H9.76416C9.70416 9.708 9.66816 9.444 9.66816 9.084C9.66816 8.232 10.1962 7.896 10.7362 7.896C11.3122 7.896 11.7202 8.172 11.9842 8.748L13.2202 8.16C12.8602 7.152 12.0082 6.504 10.7362 6.504C9.17616 6.504 8.18016 7.584 8.18016 9C8.18016 9.348 8.27616 9.66 8.37216 9.936H7.79616V11.328Z",
    fill: "#2D2926"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19H17",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23L15 23",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.57f461eb8e24c0d04cd912748ab1a823.svg";
export { ForwardRef as ReactComponent };